
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mahabaleshwartomumbaicab() {



    const cardData =
    {
        keyword: ' Mahabaleshwar to Mumbai Cab  ',
        heading: 'Deva Cabs: Mahabaleshwar to Mumbai Cab  ',
        headingDescription: 'Deva Cabs offers smooth and reliable cab services from Mahabaleshwar to Mumbai, ideal for scenic drives, family returns, and business travel. Covering a distance of approximately 260 km, our well-maintained fleet—including Sedans, SUVs, and Innova Crysta—ensures a comfortable and picturesque journey through the Western Ghats and Konkan plains. With professional chauffeurs, fixed-fare packages, and convenient door-to-door pickup, you get a relaxing and stress-free ride. Available 24/7 with transparent pricing and attentive customer support, Deva Cabs makes your Mahabaleshwar to Mumbai cab travel seamless, safe, and enjoyable.',

        top: 'Top Places to Visit in Mumbai with Deva Cabs',

"topPlaces": [
  {
    "title": "Elephanta Caves",
    "location": "Elephanta Island, Mumbai Harbour",
    "description": "A UNESCO World Heritage site reachable by an hour-long ferry ride from the Gateway. These rock-cut caves dating from the 5th–8th centuries feature grand sculptures, including the iconic Trimurti of Shiva. The island’s lush hillscape and views of the bay create a serene journey back in time."
  },
    {
    "title": "Marine Drive",
    "location": "South Mumbai, Maharashtra",
    "description": "Known as the ‘Queen’s Necklace’, this 3.6 km C-shaped promenade along the Arabian Sea is lined with art-deco buildings and palm trees. Perfect for sunset strolls or evening breezes, it lights up like a string of pearls at night. Whether it’s a quiet morning jog or enjoying street-side chai, Marine Drive encapsulates Mumbai’s coastal charm and historical elegance."
  },
  {
    "title": "Gateway of India",
    "location": "Colaba, South Mumbai, Maharashtra",
    "description": "Erected in 1924 to commemorate the visit of King George V and Queen Mary, this majestic basalt arch stands majestically by the sea, with the iconic Taj Mahal Palace Hotel beside it. A starting point for ferry trips to Elephanta Caves, it buzzes with street performers, photographers, and tourists soaking in its colonial history."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "location": "Mumbai, Maharashtra",
    "description": "This UNESCO-listed masterpiece from 1887 fuses Victorian Gothic with Indian architectural elements. A living monument, CSMT is one of India’s busiest railway stations, featuring stunning stonework, arched windows, turrets, and intricate carvings that echo Mumbai’s colonial past."
  },
  {
    "title": "Juhu Beach",
    "location": "Juhu, Mumbai, Maharashtra",
    "description": "A bustling sandy stretch known for its vibrant street-snack culture—vada pav, bhel puri, pav bhaji—sunset seekers, and Bollywood celebrity neighborhood. Joggers, kite-flyers, and families mingle here as foamy waves lap the shore, making it a quintessential slice of Mumbai life."
  },
  {
    "title": "Siddhivinayak Temple",
    "location": "Prabhadevi, Mumbai, Maharashtra",
    "description": "Renowned for its black stone idol of Lord Ganesha with a trunk curving to the right, this temple sees millions of devotees, especially on Tuesdays. The atmosphere is charged with faith, and the temple’s ornate gold-plated sanctum adds to its spiritual grandeur."
  },
  {
    "title": "Haji Ali Dargah",
    "location": "Worli, Mumbai, Maharashtra",
    "description": "A white-domed Sufi shrine built on a sea-locked islet and accessible via a narrow causeway at low tide. Known for its sense of peace amidst the waves, the Dargah draws visitors of all faiths seeking blessings and views of the open sea."
  },
  {
    "title": "Girgaon Chowpatty",
    "location": "Girgaon, South Mumbai, Maharashtra",
    "description": "At the northern end of Marine Drive, this busy beach is a hub for Ganesh Visarjan celebrations every year. Known for its lively street‑food scene—pani puri, kulfi, corn—it’s a place to soak in Mumbai's festive spirit and beach culture."
  },
  {
    "title": "Colaba Causeway & Kala Ghoda",
    "location": "Colaba & Fort, South Mumbai, Maharashtra",
    "description": "A vibrant cultural corridor known for its bohemian charm—flea markets, street art, galleries, colonial facades, chic cafés, and heritage museums. Strolling here offers tastes of fashion, art, history, and street-life all in one eclectic walk."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "location": "Borivali, Mumbai, Maharashtra",
    "description": "A verdant break from city bustle, this rare urban jungle spans over 100 km² and houses wildlife like leopards, deer, and monkeys. Within it lies the ancient Kanheri Caves—Buddhist-carved sanctuaries and temples set among forest trails and streams."
  }
],



 "services": [
    {
      "name": "Mahabaleshwar to Mumbai Cab",
      "description": "Travel comfortably from the scenic hill station of Mahabaleshwar to the bustling city of Mumbai with our reliable cab services. Whether you’re returning from a vacation or a business trip, enjoy a safe and pleasant journey in well-maintained vehicles with professional drivers."
    },
    {
      "name": "One-way cab Mahabaleshwar to Mumbai",
      "description": "Book a hassle-free one-way cab from Mahabaleshwar to Mumbai, perfect for travelers who need a direct, convenient ride without worrying about return trips. Our cabs provide punctuality, safety, and comfort for your journey."
    },
    {
      "name": "Book Mahabaleshwar to Mumbai taxi",
      "description": "Reserve your taxi from Mahabaleshwar to Mumbai quickly and easily through our online booking system. Choose from a variety of vehicle options tailored to your budget and travel needs, with 24/7 customer support."
    },
    {
      "name": "Round trip cab Mahabaleshwar to Mumbai",
      "description": "Plan a round trip between Mahabaleshwar and Mumbai with our dedicated round trip cab service. Enjoy the convenience of the same vehicle and driver for both legs of your journey, ensuring comfort and flexibility throughout."
    },
    {
      "name": "AC cab hire Mahabaleshwar to Mumbai",
      "description": "Beat the heat and travel in comfort with our air-conditioned cab services from Mahabaleshwar to Mumbai. Perfect for long journeys, our AC cabs guarantee a cool, relaxing ride with attentive drivers."
    },
    {
      "name": "SUV cab Mahabaleshwar to Mumbai",
      "description": "Need extra space for family or luggage? Our SUV cabs from Mahabaleshwar to Mumbai provide ample room and smooth travel experience. Ideal for groups, long-distance travel, or those seeking added comfort."
    },
    {
      "name": "Chauffeur-driven cab Mahabaleshwar to Mumbai",
      "description": "Sit back and relax in our chauffeur-driven cabs from Mahabaleshwar to Mumbai. Our professional drivers ensure timely pickups, safe driving, and courteous service, making your journey hassle-free."
    },
    {
      "name": "Affordable cab Mahabaleshwar to Mumbai",
      "description": "Travel from Mahabaleshwar to Mumbai without stretching your budget. Our affordable cab options combine cost-effectiveness with reliability, ensuring a comfortable ride at competitive rates."
    }
  ],
  "tableData": [
    ["Mahabaleshwar to Mumbai Cab", "-One-way cab Mahabaleshwar to Mumbai"],
    ["Book Mahabaleshwar to Mumbai taxi", "-Round trip cab Mahabaleshwar to Mumbai"],
    ["AC cab hire Mahabaleshwar to Mumbai", "-SUV cab Mahabaleshwar to Mumbai"],
    ["Chauffeur-driven cab Mahabaleshwar to Mumbai", "-Affordable cab Mahabaleshwar to Mumbai"]
  ],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mahabaleshwar to Mumbai Cab Service",
    "WhyChoosedescription": "Enjoy a comfortable and hassle-free journey from the scenic hill station of Mahabaleshwar to Mumbai with our trusted cab service. Whether you are returning from a relaxing vacation or traveling for business, our well-maintained vehicles and experienced drivers ensure a safe and timely trip covering approximately 260 km."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Vehicles for All Group Sizes",
    "WhyChoosedescription": "Our fleet features air-conditioned sedans, SUVs, and tempo travellers with ergonomic seating and ample luggage space. Whether you’re traveling solo, with family, or in a group, our vehicles provide a relaxing environment to unwind after your hill station visit."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Route and Terrain",
    "WhyChoosedescription": "Our professional drivers have extensive knowledge of the winding roads and highways between Mahabaleshwar and Mumbai. They prioritize safety, comfort, and punctuality, ensuring a smooth and stress-free journey despite the challenging terrain."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages Tailored to Your Itinerary",
    "WhyChoosedescription": "Choose from one-way, round-trip, or hourly rental options to suit your travel plans. Whether you need a quick transfer or a multi-day trip with sightseeing stops, we offer customizable packages to meet your specific needs and budget."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "Our all-inclusive pricing covers tolls, fuel, parking, and driver allowances, with no hidden charges. This transparency allows you to plan your Mahabaleshwar to Mumbai cab journey with confidence and peace of mind."
  },
  {
    "WhyChooseheading": "24/7 Availability for Your Convenience",
    "WhyChoosedescription": "We operate around the clock to accommodate your travel schedule. Whether you prefer to travel early morning or late at night, our Mahabaleshwar to Mumbai cabs are available whenever you need them."
  },
  {
    "WhyChooseheading": "Easy Booking and Instant Confirmation",
    "WhyChoosedescription": "Book your cab quickly and easily through our website or customer support. Receive instant confirmation with all necessary details, ensuring a seamless and hassle-free experience from start to finish."
  },
  {
    "WhyChooseheading": "Safe, Sanitized, and GPS-Enabled Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly sanitized and maintained to the highest standards. Equipped with GPS tracking, seat belts, and emergency kits, we prioritize your safety and comfort throughout your journey."
  }
]

















    }




const faqData = [
  {
    question: "Can I book a cab from Mahabaleshwar to Mumbai with Deva Cabs?",
    answer: "Yes, Deva Cabs provides reliable and comfortable cab services from Mahabaleshwar to Mumbai for both one-way and round-trip travel."
  },
  {
    question: "How long does it take to travel from Mahabaleshwar to Mumbai by cab?",
    answer: "The journey typically takes around 4 to 5 hours depending on traffic and weather conditions."
  },
  {
    question: "What vehicle options are available for Mahabaleshwar to Mumbai trips?",
    answer: "We offer a range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your travel needs."
  },
  {
    question: "Is one-way cab booking available from Mahabaleshwar to Mumbai?",
    answer: "Yes, Deva Cabs provides both one-way and round-trip cab services for this route."
  },
  {
    question: "Are tolls, parking fees, and driver allowances included in the fare?",
    answer: "Toll charges, parking fees, and driver allowances are usually extra and will be clearly communicated at the time of booking."
  },
  {
    question: "Can I book a cab for early morning or late-night travel from Mahabaleshwar to Mumbai?",
    answer: "Yes, our services operate 24/7, so you can schedule your trip at any time."
  },
  {
    question: "Is the trip safe and comfortable for families and senior citizens?",
    answer: "Absolutely. Our vehicles are well-maintained and drivers are experienced, ensuring a safe and comfortable journey."
  },
  {
    question: "Can I request stops for sightseeing or breaks during the trip?",
    answer: "Yes, you can request halts or sightseeing stops during your journey. Please inform us while booking."
  },
  {
    question: "Is this cab service suitable for airport transfers to Mumbai?",
    answer: "Yes, we provide timely and reliable airport transfers from Mahabaleshwar to Mumbai."
  },
  {
    question: "Why choose Deva Cabs for Mahabaleshwar to Mumbai cab service?",
    answer: "Deva Cabs offers professional drivers, clean vehicles, transparent pricing, and excellent customer support for a hassle-free experience."
  }
];

const testimonialData = [
  {
    id: 93,
    name: 'Mr. Ramesh Joshi',
    role: 'Family Traveler',
    review: 'We had a pleasant trip from Mahabaleshwar to Mumbai with Deva Cabs. The driver was very courteous and the vehicle was comfortable.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 94,
    name: 'Ms. Sneha Patil',
    role: 'Tourist',
    review: 'Booking a cab from Mahabaleshwar to Mumbai with Deva Cabs was smooth and hassle-free. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];






















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mahabaleshwar to Mumbai Cab",
  "image": "https://devacab.com/assets/images/mahabaleshwar-to-mumbai-cab.jpg", // Update with actual image URL
  "description": "Book affordable Mahabaleshwar to Mumbai cab service with AC and SUV cabs. Chauffeur-driven one-way and round trip taxi options available.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "95",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mahabaleshwar-to-mumbai-cab" // Replace with actual URL
  }
};




    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mahabaleshwar to Mumbai Cab | Taxi Service Mahabaleshwar to Mumbai | Deva Cabs</title>
  <meta
    name="description"
    content="Affordable Mahabaleshwar to Mumbai cab service with AC and SUV taxis. Chauffeur-driven one-way and round trip options. Book online with Deva Cabs."
  />
  <meta
    name="keywords"
    content="Mahabaleshwar to Mumbai Cab, One-way cab Mahabaleshwar to Mumbai, Book Mahabaleshwar to Mumbai taxi, Round trip cab Mahabaleshwar to Mumbai, AC cab hire Mahabaleshwar to Mumbai, SUV cab Mahabaleshwar to Mumbai, Chauffeur-driven cab Mahabaleshwar to Mumbai, Affordable cab Mahabaleshwar to Mumbai"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/59.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mahabaleshwartomumbaicab;